<template>
    <div v-if="branch">
        <!-- name -->
        <div class="field is-horizontal">
            <div class="field-label is-normal">
                <label class="label">Branch</label>
            </div>
            <div class="field-body">
                <div class="field">
                    <p class="control">
                        <span class="oc-form-text">{{branch.branch}}</span>
                    </p>
                </div>
            </div>
        </div>

        <!-- code -->
        <div class="field is-horizontal">
            <div class="field-label is-normal">
                <label class="label">Code</label>
            </div>
            <div class="field-body">
                <div class="field">
                    <p class="control">
                        <input v-model="branch.code" type="text" class="input oc-input" />
                    </p>
                </div>
            </div>
        </div>

        <!-- registration link -->
        <div class="field is-horizontal">
            <div class="field-label is-normal">
                <label class="label">Registration link</label>
            </div>
            <div class="field-body">
                <div class="field">
                    <p class="control">
                        <input
                            v-model="branch.registrationLink"
                            type="text"
                            class="input is-static has-text-white"
                            readonly
                        />
                    </p>
                </div>
            </div>
        </div>

        <!-- name -->
        <div class="field is-horizontal">
            <div class="field-label is-normal">
                <label class="label">Name</label>
            </div>
            <div class="field-body">
                <div class="field">
                    <p class="control">
                        <input v-model="branch.settings.name" type="text" class="input oc-input" />
                    </p>
                </div>
            </div>
        </div>

        <!-- address -->
        <div class="field is-horizontal">
            <div class="field-label is-normal">
                <label class="label">Address</label>
            </div>
            <div class="field-body">
                <div class="field">
                    <p class="control">
                        <input v-model="branch.settings.address" type="text" class="input oc-input" />
                    </p>
                </div>
            </div>
        </div>

        <!-- description -->
        <div class="field is-horizontal">
            <div class="field-label is-normal">
                <label class="label">Description</label>
            </div>
            <div class="field-body">
                <div class="field">
                    <p class="control">
                        <input v-model="branch.settings.description" type="text" class="input oc-input" />
                    </p>
                </div>
            </div>
        </div>

        <!-- is demo branch -->
        <div class="field is-horizontal">
            <div class="field-label is-normal"></div>
            <div class="field-body">
                <div class="field">
                    <p class="control">
                        <label class="checkbox">
                            <input type="checkbox" v-model="branch.isDemo" />
                            Demo branch
                        </label>
                    </p>
                </div>
            </div>
        </div>

        <!-- rtp level -->
        <div class="field is-horizontal">
            <div class="field-label is-normal">
                <label class="label">RTP level</label>
            </div>
            <div class="field-body">
                <div class="field">
                    <div class="control">
                        <div
                            class="select"
                            :class="{'is-danger': branch.settings.rtpLevel == 'veryGreedy', 'is-warning': (['slightlyGreedy', 'littleGreedy', 'greedy'].includes(branch.settings.rtpLevel))}"                            
                        >
                            <select v-model="branch.settings.rtpLevel">
                                <option :value="null">default/inherited</option>
                                <option>normal</option>
                                <option>littleGreedy</option>
                                <option>slightlyGreedy</option>
                                <option>greedy</option>
                                <option>veryGreedy</option>
                            </select>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- save -->
        <div class="field">
            <div class="control">
                <button class="button is-success" @click="save()">Save</button>
            </div>
        </div>
    </div>
</template>
<script>
import branchService from '../../../../../services/branch.service';
import clientService from '../../../../../services/client.service';

export default {
    name: 'branch-general',
    data() {
        return {
            branch: null
        };
    },
    computed: {
        clientId() {
            return Number(this.$route.params.clientId);
        },
        branchName() {
            return this.$route.params.branch;
        }
    },
    async mounted() {
        this.branch = await branchService.get(this.clientId, this.branchName);
    },
    methods: {
        async save() {
            await branchService.saveSettings(this.clientId, this.branch.branch, this.branch.settings);
            this.branch = await branchService.update(this.branch);
        }
    }
};
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// front/src/components/clients/client/branches/branch/general.vue